import * as yup from "yup";

export const ValidatePaymentMethods = yup.object().shape({
    name: yup.string().required("Nome é obrigatório").min(3, "Nome deve ter mais que três caracteres"),
    type_payment: yup.string().required("Tipo de pagamento é obrigatório").oneOf(["sight", "installments"], "Tipo de pagamento inválido"),
});
